import React, { Component } from 'react';
import ReactTable from "react-table";
import { CSVLink } from "react-csv";
import Modal from 'react-modal';
import 'react-table/react-table.css';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '400px',
    color                 : 'black'
  }
};

const _template = process.env.REACT_APP_ROOT_URL + '/files/blem-location-import.csv';

const columns = [
  { Header: "SKU", accessor: "pr_sku", width: 120 },
  { Header: "Description", accessor: "pr_desc", width: 200 },
  { Header: "UPC", accessor: "pr_upc", width: 120 },

  { Header: "Blem #", accessor: "ri_blem_number", width: 100 },
  { Header: "Location", accessor: "ri_location", width: 100 },
  { Header: "Actual Condition", accessor: "ri_actual_condition", width: 120 },

  { Header: "Total Qty", accessor: "blem_qty_total", width: 90 },
  { Header: "Sold Qty", accessor: "blem_qty_sold", width: 90 },
  { Header: "Available Qty", accessor: "blem_qty_available", width: 110 },

  { Header: "Last Updated", accessor: "ri_date_updated", width: 140 }
];

class InventoryBlemReport extends Component {

  state = {
    inventoryitems: [],
    cl_id: localStorage.getItem('headerClientId'),
    userToken: localStorage.getItem('userToken'),
    us_id: localStorage.getItem('usId'),
    resetModalIsOpen: false,
    resetModalMessage: '',
    selectedFile: null,
    clearBeforeUpload: false
  };

  componentDidMount() {
    this.loadReport();
    Modal.setAppElement('#main');
  }

  loadReport = () => {
    fetch(
      `${process.env.REACT_APP_NODE_ROOT_URL}/reports/inventory/blem/${this.state.cl_id}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'bwToken': this.state.userToken
        }
      }
    )
      .then(res => res.json())
      .then(inventoryitems => this.setState({ inventoryitems }));
  };

  openResetModal = () => {
    this.setState({ resetModalIsOpen: true, resetModalMessage: '', selectedFile: null, clearBeforeUpload: false });
  }

  closeResetModal = () => {
    this.setState({ resetModalIsOpen: false });
  }

  handleResetFileUpload = (e) => {
    e.preventDefault();
    const myFile = document.getElementById('blemUpload');
    this.setState({ selectedFile: myFile.files[0] });
  }

  handleClearBeforeUploadChange = (e) => {
    this.setState({ clearBeforeUpload: e.target.checked });
  }

  processResetFileUpload = (e) => {
    e.preventDefault();

    if (!this.state.selectedFile) {
      this.setState({ resetModalMessage: 'Please choose a file first.' });
      return;
    }

    if (this.state.clearBeforeUpload && !window.confirm('This will DELETE ALL existing blem inventory rows for this client before applying the file. This cannot be undone. Continue?')) {
      return;
    }

    const data = new FormData();
    data.append('file', this.state.selectedFile);
    data.append('us_id', this.state.us_id);
    data.append('clear_first', this.state.clearBeforeUpload);

    this.setState({ resetModalMessage: 'Uploading...' });

    fetch(`${process.env.REACT_APP_NODE_ROOT_URL}/upload/blem/${this.state.cl_id}`, {
      method: 'POST',
      body: data,
      headers: { 'bwToken': this.state.userToken }
    })
      .then(res => res.json())
      .then(data => {
        if (!data.success) {
          this.setState({ resetModalMessage: 'Upload failed. ' + (data.error || '') });
          return;
        }
        var rows = data.results || [];
        var updated = rows.filter(r => r.ok && r.action === 'updated').length;
        var inserted = rows.filter(r => r.ok && r.action === 'inserted').length;
        var needsReview = rows.filter(r => !r.ok).length;
        var clearedMsg = this.state.clearBeforeUpload ? `Deleted: ${data.clearedCount || 0}. ` : '';;
        this.setState({ resetModalMessage: `Done. ${clearedMsg}Updated: ${updated}. Inserted: ${inserted}. Needs manual review: ${needsReview}.` });
        this.loadReport();
      })
      .catch(error => this.setState({ resetModalMessage: 'Upload failed. ' + error }));
  }

  render() {
    return (
      <div className="page-wrapper" id="main">
        <div className="row page-titles">
          <div className="col-md-12 align-self-center">
            <h3 className="text-primary">Blem Inventory Report</h3>
          </div>
        </div>

        <div className="container-fluid">
          <CSVLink
            data={this.state.inventoryitems}
            filename="blem-inventory.csv"
            className="btn btn-info btn-sm"
          >
            Download CSV
          </CSVLink>{' '}

          <button type="button" className="btn btn-warning btn-sm" onClick={this.openResetModal}>Reset Locations</button>

          <Modal
            isOpen={this.state.resetModalIsOpen}
            onRequestClose={this.closeResetModal}
            style={customStyles}
            contentLabel="Reset Blem Locations"
          >
            <div className="container-fluid">
              <h4>Reset Blem Locations</h4>
              <p>Upload a CSV with <b>upc</b>, <b>blem_location</b>, and <b>actual_condition</b>. Each row represents one physical unit.</p>
              <p>Rows are grouped by UPC, location, and condition, and the count becomes the new quantity. Existing matching items are updated; new items are added to an <b>Inventory Recount</b> return.</p>
              <p>Rows not in the file are left unchanged unless the option below is selected.</p>
              <p><a href={_template} target="_blank" rel="noopener noreferrer">Download template</a></p>

              <input type="file" id="blemUpload" name="blemUpload" accept=".csv" onChange={(e) => this.handleResetFileUpload(e)} />

              <br /><br />
              <input type="checkbox" id="clearBeforeUpload" checked={this.state.clearBeforeUpload} onChange={this.handleClearBeforeUploadChange} />&nbsp;
              <label htmlFor="clearBeforeUpload"><b>Clear all BLEM inventory first</b></label>

              <div className="modalMessage">{this.state.resetModalMessage}</div>

              <br />
              <button type="button" className="btn btn-info btn-sm" onClick={this.processResetFileUpload}>Upload</button>{' '}
              <button type="button" className="btn btn-default btn-sm" onClick={this.closeResetModal}>Cancel</button>
            </div>
          </Modal>

          <ReactTable
            data={this.state.inventoryitems}
            columns={columns}
            filterable
            defaultPageSize={50}
            className="-striped -highlight"
            noDataText="Loading blem inventory..."
          />
        </div>
      </div>
    );
  }
}

export default InventoryBlemReport;
